@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.drop-area {
  display: flex;
  border: dashed 2px var(--gray-E4E5E7);
  max-width: 100%;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  height: 200px;
  cursor: pointer;
  background-color: var(--white);

  &.uploaded {
    background-color: var(--grey-200);
    border: solid 1px var(--grey-400);
  }
}

.drag-drop-area-wrapper {
  text-align: center;
}

.drag-drop-or {
  color: var(--grey-600);
}

.select-file-btn {
  margin-top: @space-4;
}

.selected-file-btn {
  margin-top: @space-8;
}

.icon {
  width: 24px;
  height: 24px;
  margin-bottom: @space-12;
  color: var(--grey-600);
}
